import { GradingRecordProps } from "../../types";
import {
  TableHead,
  TableData,
  TableGrid,
  TableRow,
  EditButton,
  TableDataNormal,
  EllipsePara,
} from "./MyTable.styles";

function MyTable(props: {
  headers: string[];
  data: GradingRecordProps[];
  handleClick(data: GradingRecordProps): void;
}) {
  const { headers, data, handleClick } = props;
  return (
    <TableGrid>
      <TableRow>
        {headers.map((col, idx) => (
          <TableHead key={idx}>{col}</TableHead>
        ))}
      </TableRow>
      {data.map((row, idx) => (
        <TableRow key={idx}>
          <TableData>{row["rating"]}</TableData>
          <TableDataNormal>{row["grades"].join(", ")}</TableDataNormal>
          <TableDataNormal>
            <EllipsePara>{row["description"]}</EllipsePara>
          </TableDataNormal>
          <TableData>
            <EditButton onClick={() => handleClick(row)}>Edit</EditButton>
          </TableData>
        </TableRow>
      ))}
    </TableGrid>
  );
}

export default MyTable;
